const NAMESPACE = "changeOwnerControl";

const KEYS = {
    changeOwnerEmailLabel: "changeOwnerEmailLabel",
    changeOwnerButton: "changeOwnerButton",
    changeOwnerConfirmationText: "changeOwnerConfirmationText",
    newOwnerEmailPrompt: "newOwnerEmailPrompt",
    changeOwnerDialogTitle: "changeOwnerDialogTitle",
    alreadyOwnerText: "alreadyOwnerText"
};

const MESSAGES = {
    [KEYS.changeOwnerEmailLabel]: {
        value: "New Owner Email Address:",
        comment: "Label for new owner email address text box"
    },
    [KEYS.changeOwnerButton]: {
        value: "Change Owner",
        comment: "Text for change owner button"
    },
    [KEYS.changeOwnerConfirmationText]: {
        value: "Are you sure you want to transfer ownership of this project from {projectOwnerEmail} to {newOwnerEmail}? The current owner will no longer have control over project ownership, project data, or documentation.",
        comment: "Text to confirm project owner transfer"
    },
    [KEYS.newOwnerEmailPrompt]: {
        value: "Please enter the email of the user to whom you want to transfer project ownership.",
        comment: "Text to prompt user to enter email of new owner"
    },
    [KEYS.changeOwnerDialogTitle]: {
        value: "Change Project Owner",
        comment: "Text for change owner dialog"
    },
    [KEYS.alreadyOwnerText]: {
        value: "{newOwnerEmail} is already the owner of this project.",
        comment: "Text to display to user if new owner is current owner"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
